import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-code': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM149.7 348.9L116.9 320 149.7 291.1A8.8-8.8 0 0 1 150.3 278.5L132.9 259.9C129.5 256.3 123.9 256.3 120.4 259.5L62.8 313.6C59.1 317.1 59.1 322.9 62.8 326.4L120.4 380.5A8.7-8.7 0 0 1 126.5 382.9 8.7-8.7 0 0 1 132.9 380.1L150.3 361.5A8.8-8.8 0 0 1 149.7 348.9zM234 221L209.6 214A8.8-8.8 0 0 1 198.7 219.9L144 408.1C142.7 412.7 145.4 417.6 150 419L174.4 426.1C179.1 427.4 184 424.7 185.3 420.1L240 231.9C241.3 227.3 238.6 222.4 234 221zM321.2 313.6L263.6 259.5C260 256.2 254.5 256.4 251.1 259.9L233.7 278.5A8.8-8.8 0 0 1 234.3 291.1L267.1 320 234.3 348.9A8.8-8.8 0 0 1 233.7 361.5L251.1 380.1A8.8-8.8 0 0 1 263.6 380.5H263.6L321.2 326.4C324.9 322.9 324.9 317.1 321.2 313.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-code.js
// module id = JnOe
// module chunks = 144